
export default {
  props: {
    filterProp: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedType: 0,
      typeOptions: {
        0: 'Any',
        1: 'Personal',
        2: 'Business',
        3: 'Freight-broker',
      },
    };
  },
  watch: {
    filterProp: {
      handler() {
        if (this.filterProp !== null) {
            this.selectedType = Number(this.filterProp)
        } else {
          this.selectedType = 0
        }
        this.$emit('value-changed', this.selectedType)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    handleChange () {
      this.$emit('value-changed', this.selectedType)
    },
  }
}
